import { useReveal } from "@/hooks/useReveal";

export default function CaseStudy() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="case-study" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div
          ref={ref}
          className="reveal grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center"
        >
          <div className="w-full">
            <img
              src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/321c073a-97ad-44cb-87e7-c8b88dcd5474_compressed_alejandria-private-label-chile.webp"
              alt="Unbranded kraft pouch of organic whole cane sugar developed for a private label range"
              loading="lazy"
              className="w-full h-[280px] md:h-[460px] object-cover object-top rounded-lg"
            />
          </div>

          <div>
            <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold leading-tight">
              A complete range, concept to shelf, in under four months
            </h2>
            <p className="mt-5 text-ink/70 text-[17px] leading-relaxed">
              A supermarket distributor in Chile came to us wanting an organic
              sweetener line under their own brand, not ours. We developed the
              range with them: product specification, formats, packaging and
              export documentation, and it reached the shelf in under four
              months. It is the clearest answer we have to the question of
              whether a small certified plant can actually deliver a full
              private label programme.
            </p>
            <p className="mt-5 text-ink/50 text-sm">
              Brand and client details available under NDA on request.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}